var render = function render(){var _vm=this,_c=_vm._self._c;return _c('verte',_vm._b({on:{"input":_vm.save}},'verte',_vm.$props,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }